import { api } from "@/lib/api";

const REF_EMAIL_KEY = "lc_ref_email";
const ENGINE_KEY = "lc_engine_mode";

function sessionId() {
  let s = localStorage.getItem("lc_session_id");
  if (!s) {
    s = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("lc_session_id", s);
  }
  return s;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Capture a cold-email lead identifier from ?ref_email= or ?email= and persist it.
// Fires a one-time tracked_link_visit so pure link clicks (no further action) still count.
export function captureRefEmail() {
  try {
    const p = new URLSearchParams(window.location.search);
    const em = (p.get("ref_email") || p.get("email") || "").trim().toLowerCase();
    if (em && EMAIL_RE.test(em)) {
      const prev = localStorage.getItem(REF_EMAIL_KEY);
      localStorage.setItem(REF_EMAIL_KEY, em);
      // Log a visit whenever a tracking link is followed (new lead or a re-click).
      if (p.get("ref_email") || p.get("email")) {
        setTimeout(() => track("tracked_link_visit", { fresh: prev !== em }), 0);
      }
    }
  } catch { /* no-op */ }
}

export function getRefEmail() {
  return localStorage.getItem(REF_EMAIL_KEY) || undefined;
}

// Persisted current engine mode ("demo"/"managed" or "byo") so events carry it.
export function setEngineMode(mode) {
  if (mode) localStorage.setItem(ENGINE_KEY, mode === "byo" ? "byo" : "demo");
}
function getEngineMode() {
  return localStorage.getItem(ENGINE_KEY) || undefined;
}

// English-only launch: no third-party IP lookup. Default pricing currency is USD.
export function isHongKong() {
  return false;
}
export function getDefaultCurrency() {
  return "usd";
}

// Fire-and-forget analytics event. Never blocks or throws in the UI.
export function track(event, meta = {}) {
  try {
    const ref_email = getRefEmail();
    const payload = {
      event,
      session_id: sessionId(),
      user_email: ref_email,
      meta: { ref_email, engine: getEngineMode(), ...meta },
    };
    api.post("/track", payload).catch(() => {});
  } catch {
    /* no-op */
  }
}
